import React from 'react';
import {Shop} from 'interfaces';
import {ListingCards} from 'components/Marketplace/ListingCards';
import {ShopEmpty} from '../ShopEmpty';

export interface ShopDisplayProps {
  shops: Shop[];
  loading?: boolean;
  countString: string;
}

export function ShopDisplay({shops, loading, countString}: ShopDisplayProps) {
  if (!shops.length) {
    return <ShopEmpty />;
  }

  return <ListingCards shops={shops} loading={loading} countString={countString} />;
}
